import React from "react";
import "./Styles/JobPreviewModal.css";
import {
  currencySymbols,
  currencyLabels,
  frequencyLabels,
  categoryMap,
  jobTypeLabels,
} from "../utils/jobMapping";
import {
  ClockCircleOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  ToolOutlined,
} from "@ant-design/icons";

const JobPreviewModal = ({ isOpen, onClose, jobData, onPublish }) => {
  if (!isOpen) return null;

  // Normalize fields
  const basics = jobData?.basics || {};
  const compensation = jobData?.compensation || {};
  const title = basics.title || basics.jobTitle || "Job Title";
  const location = basics.location || "";
  const jobType = basics.job_type || basics.jobType || "";
  const category = basics.category || "";
  const expirationRaw = basics.expiration_date || basics.expirationDate;
  const categoryName = categoryMap[category] || category || "";
  const jobTypeLabel = jobTypeLabels[jobType] || jobType || "";

  const minSalary = compensation.minimum ?? jobData?.minimumAmount;
  const maxSalary = compensation.maximum ?? jobData?.maximumAmount;
  const currency = compensation.currency ?? jobData?.currencySelector;
  const salaryDate = compensation.salary_date ?? jobData?.payFrequency;

  const image = jobData?.media?.image;

  //   console.log("Currency:", currency);
  //   console.log("Min-Salary:", minSalary);
  //   console.log("Max-Salary:", maxSalary);

  const formatSalary = (amount) => {
    if (!amount && amount !== 0) return "Not specified";
    const symbol = currencySymbols[currency] || currency || "";
    return `${symbol}${parseInt(amount).toLocaleString("en-NG")}`;
  };

  const formatFrequency = frequencyLabels[salaryDate] || "";

  const shouldShowSalary = () => {
    return (minSalary || minSalary === 0) && (maxSalary || maxSalary === 0);
  };

  const formatImageSource = (img) => {
    if (typeof img === "string") return img;
    if (img instanceof File) return URL.createObjectURL(img);
    return null;
  };

  return (
    <div className="preview-modal-overlay">
      <div className="preview-modal-container">
        <div className="preview-modal-header">
          <h2>Job Details</h2>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="preview-modal-content">
          <h1 className="preview-job-title">{title}</h1>

          {/* Image */}
          {image && (
            <div className="preview-job-image-container">
              <img
                src={formatImageSource(image)}
                alt="Job preview"
                className="preview-job-image"
              />
            </div>
          )}

          <div className="preview-meta-info">
            {location && (
              <div className="preview-meta-item">
                <EnvironmentOutlined className="preview-meta-icon" />
                <span>{location}</span>
              </div>
            )}
            {jobType && (
              <div className="preview-meta-item">
                <ClockCircleOutlined className="preview-meta-icon" />
                <span>{jobTypeLabel}</span>
              </div>
            )}
            {category && (
              <div className="preview-meta-item">
                <ToolOutlined className="preview-meta-icon" />
                <span>{categoryName}</span>
              </div>
            )}
          </div>

          <div className="preview-divider"></div>

          {/* Description */}
          <div className="preview-section">
            <h3 className="preview-section-title">Job Description</h3>
            {jobData?.description ? (
              <div
                className="preview-html-content"
                dangerouslySetInnerHTML={{
                  __html:
                    typeof jobData.description === "string"
                      ? jobData.description
                      : jobData.description?.html || "",
                }}
              />
            ) : (
              <p>No description provided</p>
            )}
          </div>

          <div className="preview-divider"></div>

          {/* Deadline */}
          <div className="preview-deadline">
            <strong>Application Deadline: </strong>
            <span>
              {expirationRaw
                ? new Date(expirationRaw)
                  .toLocaleDateString("en-GB")
                  .replace(/\//g, "-")
                : "Not specified"}
            </span>
          </div>

          {/* Salary Info */}
          <div className="preview-salary-container">
            <div className="preview-salary-icon">
              <DollarOutlined />
            </div>
            <div className="preview-salary-details">
              <div className="preview-salary-row">
                <span className="preview-salary-label">Range:</span>
                <span className="preview-salary-value">
                  {shouldShowSalary()
                    ? `${formatSalary(minSalary)} - ${formatSalary(maxSalary)}`
                    : "Not specified"}
                </span>
              </div>
              {/* Frequency Row */}
              <div className="preview-salary-row">
                <span className="preview-salary-label">Frequency:</span>
                <span className="preview-salary-value">
                  {formatFrequency || "Not specified"}
                </span>
              </div>

              {/* Currency Row */}
              <div className="preview-salary-row">
                <span className="preview-salary-label">Currency:</span>
                <span className="preview-currency">
                  {currencyLabels[currency] || currency || "Not specified"}
                </span>
              </div>

            </div>
          </div>
        </div>

        <div className="preview-modal-footer">
          <button className="preview-close-btn" onClick={onClose}>
            Close Preview
          </button>
          {onPublish && (
            <button
              className="preview-publish-btn"
              onClick={onPublish}
            >
              Publish Job
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default JobPreviewModal;
